class ImageTextInvertable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiperContainer = this.querySelector('.image__text-slider');
    
    if (!swiperContainer) return;

    swiperContainer.slidesQuantity = swiperContainer.querySelectorAll(".swiper-slide").length;

    function updSwiperNumericPagination() {
      const counters = this.el.querySelectorAll(".swiper-counter");
      counters.forEach(counter => {
        counter.innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + this.el.slidesQuantity + "</span>";
      });
    }

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      centeredSlides: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      autoHeight: true,
      speed: 600,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      on: {
        init: updSwiperNumericPagination,
        slideChange: updSwiperNumericPagination
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('image-text-invertable', ImageTextInvertable); 